import vi from './vi';
import en from './en';
let langLocal = localStorage.getItem('ob_cl_language');
let lang = langLocal == 'en' ? en : vi;
export default lang;